import React from "react";
import { Rule } from "context/interfaces/GameContextInterface";
// Css
import classes from "./RevealAbilityItem.module.scss";

interface Props {
  item: Rule;
  reveal: boolean;
}

const RevealAbilityItem: React.FC<Props> = ({ item, reveal }) => {
  return (
    <div className={classes.policy_wrapper}>
      {!reveal && (
        <img
          className={classes.policy}
          src="assets/img/board/policy.svg"
          alt=""
        />
      )}
      {reveal && (
        <>
          {item === Rule.Liberal ? (
            <img
              className={classes.policy}
              src="assets/img/board/rule-liberal.svg"
              alt=""
            />
          ) : (
            <img
              className={classes.policy}
              src="assets/img/board/rule-fascist.svg"
              alt=""
            />
          )}
        </>
      )}
    </div>
  );
};

export default RevealAbilityItem;
